import { createFileRoute } from "@tanstack/react-router";

import { LocalModelsPage } from "../components/settings/LocalModelsPage";

function SettingsLocalModelsRoute() {
  return <LocalModelsPage />;
}

export const Route = createFileRoute("/settings/local-models")({
  component: SettingsLocalModelsRoute,
});
